import { render, staticRenderFns } from "./AutomatedAIMarketing.vue?vue&type=template&id=2ff6926f&scoped=true&"
import script from "./AutomatedAIMarketing.vue?vue&type=script&lang=ts&"
export * from "./AutomatedAIMarketing.vue?vue&type=script&lang=ts&"
import style0 from "./AutomatedAIMarketing.vue?vue&type=style&index=0&id=2ff6926f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff6926f",
  null
  
)

export default component.exports